import { Image, Text, View } from '@react-pdf/renderer';

import logoMain from '@assets/logo/logo-main.png';
import { styleSheet } from '../style-sheet';

export type ProposalDocumentHeaderProps = {
	customer: any,
	project: any,
	kitchen: any,
	date: string,
	pageName: string,
	image: string
}

export const ProposalDocumentPageHeader = (props: ProposalDocumentHeaderProps): React.ReactElement => {
	const { customer, project, kitchen, date, pageName, image } = props;

	const customerName = kitchen?.designDetails?.customerName?.isCustom
		? kitchen.designDetails.customerName.value
		: `${customer.firstName} ${customer.lastName}`;

	return (
		<View style={styleSheet.header3Column}>
			<View style={styleSheet.headerSingleColumn}>
				<Image src={image} style={styleSheet.pageHeaderImage} />
			</View>
			<View style={styleSheet.headerSingleColumn}>
				<Image src={logoMain} style={styleSheet.pageHeaderImage} />
			</View>
			<View style={[styleSheet.headerSingleColumn, styleSheet.pullRight]}>
				<Text style={styleSheet.fontWeightBold}>{customerName}</Text>
				<Text>{ kitchen.kitchenLayout } | {Math.floor(kitchen.size.width / 12)}ft Grill Island</Text>
				<Text>Designer: {project[0].designer?.firstName} {project[0].designer?.lastName}</Text>
				<Text>Creation Date: {date}</Text>
				{ pageName !== '' && <Text style={styleSheet.pageName}>{pageName}</Text> }
			</View>
		</View>
	);
};
